import "./style.css";

export default class ProcessPayment {
  static selector = ".process-payment";

  constructor(block) {
    this.block = block;
  }

  onReady() {
    if (window.location.href.indexOf("&reloaded=") < 0) {
      var newUrl = new URL(window.location.href);
      newUrl.searchParams.append("reloaded", "1");
      window.location.href = newUrl;
    }
  }

  onResize() {}

  onDestroy() {}
}
